// extracted by mini-css-extract-plugin
module.exports = {"placeholderfont":"Placeholder_placeholderfont__2yvl3","placeholdertaglinetypography":"Placeholder_placeholdertaglinetypography__1bAji"};